document.addEventListener("DOMContentLoaded", function () {
    if ($("#search-page")) {
        const vm = new Vue({
        el: "#search-page",
        data: {

            tabs: [
            "Все",
            "Идут торги",
            "Подача заявок",
            "Остановлен",
            "ДокуЗавершенменты"
            ],
            selectedTabId: 0,
        }
        });
    }
})